import {
    FETCH_DIAGNOSTICOS_REQUEST,
    FETCH_DIAGNOSTICOS_SUCCESS,
    FETCH_DIAGNOSTICOS_FAILURE,
    ADD_DIAGNOSTICO,
    MARK_DIAGNOSTICO_PLANIFICADO
} from "./diagnosticosTypes";
import { fetchDiagnosticosByPaciente as fetchService } from "../../services/firebase/diagnosticos";
import { httpRequest, httpSuccess, httpFailure } from "../sesion/sesionActions";

export const fetchDiagnosticos = (pacienteId, empresaId) => {
    return async (dispatch, getState) => {
        dispatch({ type: FETCH_DIAGNOSTICOS_REQUEST });
        dispatch(httpRequest());
        try {
            const empId = empresaId || (getState().paciente && getState().paciente.empresaId);
            const diagnosticos = await fetchService(pacienteId, empId);
            dispatch({ type: FETCH_DIAGNOSTICOS_SUCCESS, payload: diagnosticos });
            dispatch(httpSuccess());
        } catch (error) {
            dispatch({ type: FETCH_DIAGNOSTICOS_FAILURE, payload: error.message });
            dispatch(httpFailure(error));
        }
    };
};

export const addDiagnosticoLocal = (diagnostico) => ({
    type: ADD_DIAGNOSTICO,
    payload: diagnostico
});

export const setDiagnosticoPlanificadoLocal = (id) => ({
    type: MARK_DIAGNOSTICO_PLANIFICADO,
    payload: id
});
